// Copyright (c) 2016 Deere & Company

import './theme-settings.scss';
import React, {PropTypes} from 'react';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import Modal from '../../../product/shared/state/modal';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import SettingsHeader from '../../shared/components/settings-header';
import ThemeSettingsModel from '@deere/cps-it.warranty-model-factory/lib/theme-settings';
import {withRouter} from 'react-router';

let unListen;

function handlePreferredThemeChange(preferredThemeKey) {

    this.actions.updateThemePreferredTheme(preferredThemeKey, this.userThemeSettings.preferredTheme.allowedPreferredThemes);

}

function handleUserSettingsSave() {

    this.actions.updateUserSettings();

}

function handleConfirmSaveModal() {

    this.actions.confirmSaveModal(this.nextLocation);

}

function handleCloseConfirmationModal() {

    this.actions.closeConfirmSaveModal(this.nextLocation);

}
class ThemeSettings extends React.Component {

    componentWillMount() {

        this.props.actions.updateIsSaved(true);

        unListen = this.props.router.listenBefore(nextLocation => this.props.actions.handleOnPageLeave(nextLocation, this.props));

    }

    componentWillUnmount() {

        unListen();

    }

    render() {

        return (
            <section className='theme-settings'>
                <SettingsHeader
                    className='theme-settings-header'
                    isSaveDisabled={this.props.isSaved}
                    onSave={this.props::handleUserSettingsSave}
                    title='THEME'
                />
                <section className='theme-settings-panel'>
                    <OptionsDropDown
                        className='preferred-theme'
                        isPlaceholderTranslated={false}
                        label='PREFERRED_THEME'
                        onChange={this.props::handlePreferredThemeChange}
                        optionDisplayAttributes={['value']}
                        optionKey='key'
                        options={this.props.userThemeSettings.preferredTheme.allowedPreferredThemes}
                        placeholder='SELECT_THEME'
                        selectedValue={this.props.userThemeSettings.preferredTheme.key}
                    />
                </section>
                <ConfirmationModal
                    confirmMessage='DO_YOU_WANT_TO_SAVE_YOUR_CHANGES'
                    isOpen={this.props.confirmSaveModal.isVisible}
                    onClose={this.props::handleCloseConfirmationModal}
                    onConfirm={this.props::handleConfirmSaveModal}
                    title='SAVE_CHANGES'
                />
            </section>
        );

    }

}

ThemeSettings.displayName = 'ThemeSettings';
ThemeSettings.propTypes = {
    actions: PropTypes.object.isRequired,
    confirmSaveModal: PropTypes.instanceOf(Modal).isRequired,
    isSaved: PropTypes.bool.isRequired,
    nextLocation: PropTypes.string.isRequired,
    router: PropTypes.object.isRequired,
    userThemeSettings: PropTypes.instanceOf(ThemeSettingsModel).isRequired
};

export default withRouter(ThemeSettings);



// WEBPACK FOOTER //
// ./src/user/theme-settings/components/theme-settings.js